import { useAuthStore } from '../store/authStore';

const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.PROD ? '' : 'http://localhost:3001');

// Custom fetch that adds phone auth via query params
async function fetchWithAuth(url: string, options?: RequestInit): Promise<Response> {
  // Get user from authStore
  const authUser = useAuthStore.getState().user;

  // Build full URL
  let fullUrl = url.startsWith('http') ? url : `${API_URL}${url}`;

  // Add auth params to URL if user exists
  if (authUser) {
    const separator = fullUrl.includes('?') ? '&' : '?';
    fullUrl = `${fullUrl}${separator}_auth_user_id=${encodeURIComponent(authUser.id)}&_auth_user_email=${encodeURIComponent(authUser.email)}`;
    console.log('[Client] Adding auth params for user:', authUser.id);
  }

  return fetch(fullUrl, options);
}

// Simple auth methods for phone login
const auth = {
  async getSession() {
    const authUser = useAuthStore.getState().user;
    if (authUser) {
      return { data: { user: authUser } };
    }
    return { data: null };
  },

  async signOut() {
    useAuthStore.getState().reset();
    return { error: null };
  },
};

// Export client
export const client = {
  auth,
  api: {
    fetch: fetchWithAuth,
  },
};
